<template>
  <div>
    <b-row>
      <b-col
        lg="3"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/sensoricon.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
            color="#ffffff"
          >
            <div>
              <span style="font-weight: 600; font-size:20px">จำนวนจุดติดตั้งทั้งหมดทั้งหมด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px;"
            >
              ตัว
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>

      <b-col
        lg="3"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/Online.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
            color="#ffffff"
          >
            <div>
              <span style="font-weight: 600; font-size:20px; margin-left: 5px;">ระดับน้ำปกติ</span>
            </div>
          </foreignObject>
          <foreignObject
            x="30"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px;">
              {{ online.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px;"
            >
              ตัว
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/Offline.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
            color="#ffffff"
          >
            <div>
              <span style="font-weight: 600; font-size:20px; margin-left: 5px;">ระดับน้ำ 10 ซม.</span>
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px;">
              {{ offline.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px;"
            >
              ตัว
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>

      <b-col
        lg="3"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/Offline.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
            color="#ffffff"
          >
            <div>
              <span style="font-weight: 600; font-size:20px; margin-left: 5px;">ระดับน้ำ 20 ซม.</span>
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px;">
              {{ offline.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px;"
            >
              ตัว
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BImg,
  },
  data() {
    return {
      total: '',
      online: '',
      offline: '',
      totalLocation: '',
      totalWayID: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getSumCCTV()
    this.getCCTVTop()
    this.interval = setInterval(() => {
      this.getSumCCTV()
      this.getCCTVTop()
    }, 300000)
  },
  methods: {
    getCCTVTop() {
      axios
        .post('/getTop5CCTVTotal', { department: this.userData.department, username: this.userData.username })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.totalLocation = response.data[0].Total
          this.totalWayID = response.data[0].WayID
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSumCCTV() {
      axios
        .post('/getSumCCTVTotal', { department: this.userData.department })
        .then(response => {
          this.total = response.data[0].Total
          this.online = response.data[0].Online
          this.offline = response.data[0].Offline
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>
</style>
